/**
 * The language support policy (DEC-147).
 *
 * Scan-independent on purpose: someone evaluating TDIA should be able to read what it
 * covers before pointing it at a repository, and the answer must not depend on whichever
 * repo was scanned last.
 */
import { http } from './client'
import type { LanguageSupportResponse } from '../types/api'

export const languagesApi = {
  support: (): Promise<LanguageSupportResponse> => http.get('/api/v1/languages'),
}
